export const isPaymentSuccessful = (response) => {
  return (
    response?.data?.status === "PAID" ||
    response?.data?.status === "OK" ||
    response?.data?.psidStatus === "PAID"
  );
};

export const getConsumerNumber = (response) => {
  return response?.data?.consumerNumber || response?.data?.psid || "";
};

export const getActivatedPlanId = ({ response, psidData, selectedPlan }) => {
  return (
    response?.data?.planId ||
    psidData?.planId ||
    selectedPlan?.id ||
    selectedPlan?.title
  );
};
